<template>
  <div>
    <v-navigation-drawer v-if="!$vuetify.breakpoint.mobile" :mini-variant="mini" permanent clipped dark app
      class="pt-2">
      <v-list dense nav class="py-0">
        <v-list-item-group v-model="selectedItemMenu" mandatory>
          <v-list-item v-for="(item, i) in itemsNav" :key="i" @click="linkTo(item)">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> {{ item.title }} </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <div class="mb-2 d-flex align-center justify-center mx-4">
          <v-btn :x-small="mini" :block="!mini" class="py-5" color="teal darken-3" @click="showSuggestionsDialog">
            <v-icon>
              mdi-chat-question-outline
            </v-icon>
            <span class="ml-2" v-if="!mini">
              Sugerencias
            </span>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-bottom-navigation v-model="selectedItemMenu" v-if="$vuetify.breakpoint.mobile" fixed dark color="white">
      <div style="display: flex; overflow-x: auto; overflow-y: hidden; scrollbar-color: transparent;">
        <v-btn v-for="(item, i) in itemsNav" v-bind:key="i" @click="linkTo(item)">
          <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
        <v-btn v-if="$vuetify.breakpoint.smAndDown" class="fab-suggestions" fab dark color="teal darken-2"
          @click="showSuggestionsDialog" aria-label="Sugerencias">
          <v-icon> mdi-chat-question-outline</v-icon>
        </v-btn>
      </div>
    </v-bottom-navigation>
    <v-dialog v-model="suggestionsDialog" fullscreen hide-overlay transition="dialog-bottom-transition"
      v-if="$vuetify.breakpoint.mobile">
      <v-card class="d-flex flex-column">
        <div class="d-flex align-center justify-between px-4 py-2"
          style="background: linear-gradient(90deg, #003e2c, #00897b);">
          <v-spacer />
          <v-btn icon @click="closeDialog" color="white"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <iframe class="flex-grow-1" :src="iframeSrc" frameborder="0" marginheight="0" marginwidth="0">Cargando…</iframe>
      </v-card>
    </v-dialog>
    <div v-else-if="suggestionsDialog" class="suggestion-overlay">
      <transition name="fade-slide">
        <div class="suggestion-card">
          <v-card elevation="8" class="overflow-hidden">
            <!-- HERO con imagen de fondo + degradado -->
            <div class="hero">
              <div class="hero-overlay"></div>
              <div class="hero-content">
                <v-icon class="mr-3" dark>mdi-lightbulb-on-outline</v-icon>
                <span class="hero-title">Sugerencias</span>
                <v-spacer />
                <v-btn icon @click="closeDialog" class="hero-close">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Iframe del formulario -->
            <iframe :src="iframeSrc" width="100%" height="600" frameborder="0" style="border:none">Cargando…</iframe>
          </v-card>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavigationDrawer",
  props: {
    mini: Boolean,
  },
  data() {
    return {
      suggestionsDialog: false,
      selectedItemMenu: 0,
      iframeSrc: "https://docs.google.com/forms/d/e/1FAIpQLSdpa3tQS5UHi9Nt5DtOdtmaqzdpMsffbQodOL6C3arsjOs1HA/viewform?embedded=true",
      itemsNav: [
        {
          title: "Panel de control",
          icon: "mdi-view-dashboard",
          route: "Panel",
        },
        {
          title: "Contadores",
          icon: "mdi-watch-vibrate",
        },
        {
          title: "Grupos",
          icon: "mdi-ungroup",
        },
        {
          title: "Programaciones",
          icon: "mdi-calendar-blank-multiple",
        },
        {
          title: "Análisis",
          icon: "mdi-chart-line",
        },
        {
          title: "Informes",
          icon: "mdi-file-document-multiple-outline",
        },
        {
          title: "Configuración",
          icon: "mdi-cog-outline",
        },
        // {
        //   title: "Alarmas",
        //   icon: "mdi-bell-outline",
        // }
      ],
    };
  },
  computed: {},
  methods: {
    showSuggestionsDialog() {
      this.suggestionsDialog = true;
    },
    closeDialog() {
      this.suggestionsDialog = false;
    },
    linkTo: function (item) {
      let url = item.route ?? item.title
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/\s/g, "%20");
      // Si la ruta actual es igual a la siguiente ruta no sucede nada
      if (this.$route.path.slice(1) === url) return -1;
      this.$router.push(url);
    },
    formatTitle(title) {
      return title.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
  },
  beforeMount() {
    const index = this.itemsNav.findIndex(item => this.formatTitle(item.title) === this.$route.name);
    this.selectedItemMenu = index;
  }
};
</script>

<style scoped>
/* Overlay de fondo */
.suggestion-overlay {
  position: fixed;
  inset: 0;
  backdrop-filter: blur(6px);
  background: rgba(0, 0, 0, .35);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.suggestion-card {
  width: 860px;
  max-width: 95vw;
  animation: slideUpFade .3s ease-out;
}

.hero {
  position: relative;
  height: 140px;
  background-image: url('../assets/bg_user_demo.png');
  background-size: cover;
  background-position: center;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  /* Degradado: oscuro arriba -> transparente abajo */
  background: linear-gradient(180deg, rgba(0, 60, 45, .90) 0%, rgba(2, 97, 88, 0.65) 40%, rgba(0, 137, 123, .20) 100%);
}

.hero-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px;
  color: #fff;

}

.hero-title {
  font-size: 25px;
  letter-spacing: .3px;
}

.hero-close {
  color: #fff !important;
}

/* Animación */
@keyframes slideUpFade {
  from {
    transform: translateY(30px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.fade-slide-enter-active {
  animation: slideUpFade .3s ease-out;
}
</style>